import { render } from "./NouvellesVue.vue?vue&type=template&id=6ab25806"
import script from "./NouvellesVue.vue?vue&type=script&lang=js"
export * from "./NouvellesVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__